import React, {Component} from "react";
import classNames from "classnames";
import $ from 'jquery'
import {FormattedMessage} from "react-intl";
import media from '../../../i18n/media/media'

export default class Navbar extends Component {

  componentDidMount() {
    $('body').css({'overflow-y': 'auto'});
    window.onscroll = function () {
      if ($('.path-home, .path-pricing, .path-enterprise, .path-solutions').length) {
        const shadow = document.getElementById('homeflow-navbar-site');

        if (document.body.scrollTop > 15 || document.documentElement.scrollTop > 15) {
          shadow.classList.add('homeflow-navbar-site-collapsed');
        } else {
          shadow.classList.remove('homeflow-navbar-site-collapsed')
        }
      }
    };
  }

  render() {
    return (
      <header className={'header-site'}>
        <nav
          className="navbar navbar-expand-lg navbar-light bg-white homeflow-navbar fixed-top homeflow-navbar-site-collapsed-site"
          id="homeflow-navbar-site">

          <div className="container">
            <a href={'/'} className="navbar-brand">
              <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="2800" height="600" viewBox="0 0 2800 600">
                <defs>
                  <path id="homeflow-v3-line-white-svg-a" d="M142.934443,415.779888 L142.934443,212.953863 C142.934443,197.3239 155.140443,184.965325 170.577443,184.965325 C186.014443,184.965325 198.220443,197.3239 198.220443,212.953863 L198.220443,287.832288 L300.176443,287.832288 L300.176443,212.953863 C300.176443,197.3239 312.382443,184.965325 327.819443,184.965325 C343.256443,184.965325 355.462443,197.3239 355.462443,212.953863 L355.462443,415.779888 C355.462443,431.40985 343.256443,443.768425 327.819443,443.768425 C312.382443,443.768425 300.176443,431.40985 300.176443,415.779888 L300.176443,339.447513 L198.220443,339.447513 L198.220443,415.779888 C198.220443,431.40985 186.014443,443.768425 170.577443,443.768425 C155.140443,443.768425 142.934443,431.40985 142.934443,415.779888 Z"/>
                </defs>
                <g fill="none" fillRule="evenodd">
                  <rect width="2800" height="600"/>
                  <path fill="#333333" fillRule="nonzero" d="M689.686847,496 L689.686847,225.1 L749.284847,225.1 L749.284847,332.299 L859.192847,332.299 L859.192847,225.1 L918.790847,225.1 L918.790847,496 L859.192847,496 L859.192847,387.253 L749.284847,387.253 L749.284847,496 L689.686847,496 Z M1160.65176,468.668664 L1160.00485,469.297 C1138.59074,490.195104 1111.88801,500.644 1079.89585,500.644 C1047.90369,500.644 1021.26545,490.259604 999.980347,469.4905 C978.695241,448.721396 968.052847,423.115152 968.052847,392.671 C968.052847,362.484849 978.824239,336.943104 1000.36735,316.045 C1021.91045,295.146896 1048.67769,284.698 1080.66985,284.698 C1112.66201,284.698 1139.30024,295.082396 1160.58535,315.8515 C1181.87045,336.620604 1192.51285,362.226848 1192.51285,392.671 C1192.51285,422.555289 1181.89259,447.887596 1160.65176,468.668664 L1160.65176,468.668664 Z M1080.66985,449.947 C1096.92393,449.947 1109.9528,444.464555 1119.75685,433.4995 C1129.5609,422.534445 1134.46285,408.925081 1134.46285,392.671 C1134.46285,376.932921 1129.3674,363.452556 1119.17635,352.2295 C1108.9853,341.006444 1095.89193,335.395 1079.89585,335.395 C1063.64177,335.395 1050.6129,340.877445 1040.80885,351.8425 C1031.0048,362.807555 1026.10285,376.416919 1026.10285,392.671 C1026.10285,408.409079 1031.1983,421.889444 1041.38935,433.1125 C1051.5804,444.335556 1064.67377,449.947 1080.66985,449.947 Z M1235.58285,496 L1235.58285,288.568 L1294.40685,288.568 L1294.40685,317.98 C1311.69293,295.791889 1332.07473,284.698 1355.55285,284.698 C1383.15899,284.698 1402.63779,295.66289 1413.98985,317.593 C1432.82394,295.66289 1455.52771,284.698 1482.10185,284.698 C1504.28996,284.698 1521.51129,291.212435 1533.76635,304.2415 C1546.02141,317.270565 1552.14885,336.168876 1552.14885,360.937 L1552.14885,496 L1493.32485,496 L1493.32485,380.287 C1493.32485,352.164859 1481.84396,338.104 1458.88185,338.104 C1447.78779,338.104 1439.08038,341.715964 1432.75935,348.94 C1426.43832,356.164036 1423.27785,366.612932 1423.27785,380.287 L1423.27785,496 L1364.45385,496 L1364.45385,380.287 C1364.45385,352.164859 1352.97296,338.104 1330.01085,338.104 C1318.91679,338.104 1310.20938,341.715964 1303.88835,348.94 C1297.56732,356.164036 1294.40685,366.612932 1294.40685,380.287 L1294.40685,496 L1235.58285,496 Z M1702.03085,500.644 C1670.55469,500.644 1644.62595,490.6466 1624.24385,470.6515 C1603.86175,450.6564 1593.67085,424.66316 1593.67085,392.671 C1593.67085,362.484849 1603.34575,336.943104 1622.69585,316.045 C1642.04594,295.146896 1666.5557,284.698 1696.22585,284.698 C1728.99201,284.698 1754.01776,295.533892 1771.30385,317.206 C1788.41707,338.661387 1797.05912,365.04729 1797.23025,396.364485 L1797.23285,397.315 C1797.23285,400.411015 1796.97485,405.570964 1796.45885,412.795 L1652.10785,412.795 C1654.94586,425.953066 1660.7508,436.014965 1669.52285,442.981 C1678.29489,449.947035 1689.38878,453.43 1702.80485,453.43 C1721.12294,453.43 1737.89277,446.335071 1753.11485,432.145 L1786.78385,461.944 C1765.88574,487.744129 1737.63503,500.644 1702.03085,500.644 Z M1651.33385,376.03 L1739.95685,376.03 C1738.15084,362.613933 1733.44239,351.90704 1725.83135,343.909 C1718.22031,335.91096 1708.35191,331.912 1696.22585,331.912 C1684.35779,331.912 1674.48939,335.846461 1666.62035,343.7155 C1658.75131,351.584539 1653.65586,362.355932 1651.33385,376.03 Z M1851.52585,496 L1851.52585,338.878 L1827.14485,338.878 L1827.14485,290.503 L1851.52585,290.503 L1851.52585,277.345 C1851.52585,254.898888 1857.07279,238.129055 1868.16685,227.035 C1879.0029,216.198946 1894.86974,210.781 1915.76785,210.781 C1931.50593,210.781 1945.43779,212.715981 1957.56385,216.586 L1957.56385,265.348 C1948.2758,261.993983 1939.37489,260.317 1930.86085,260.317 C1916.67078,260.317 1909.57585,267.798925 1909.57585,282.763 L1909.57585,290.89 L1957.17685,290.89 L1957.17685,338.878 L1910.34985,338.878 L1910.34985,496 L1851.52585,496 Z M1992.00685,496 L1992.00685,213.49 L2050.83085,213.49 L2050.83085,496 L1992.00685,496 Z M2289.20876,468.668664 L2288.56185,469.297 C2267.14774,490.195104 2240.44501,500.644 2208.45285,500.644 C2176.46069,500.644 2149.82245,490.259604 2128.53735,469.4905 C2107.25224,448.721396 2096.60985,423.115152 2096.60985,392.671 C2096.60985,362.484849 2107.38124,336.943104 2128.92435,316.045 C2150.46745,295.146896 2177.23469,284.698 2209.22685,284.698 C2241.21901,284.698 2267.85724,295.082396 2289.14235,315.8515 C2310.42745,336.620604 2321.06985,362.226848 2321.06985,392.671 C2321.06985,422.555289 2310.44959,447.887596 2289.20876,468.668664 L2289.20876,468.668664 Z M2209.22685,449.947 C2225.48093,449.947 2238.5098,444.464555 2248.31385,433.4995 C2258.1179,422.534445 2263.01985,408.925081 2263.01985,392.671 C2263.01985,376.932921 2257.9244,363.452556 2247.73335,352.2295 C2237.5423,341.006444 2224.44893,335.395 2208.45285,335.395 C2192.19877,335.395 2179.1699,340.877445 2169.36585,351.8425 C2159.5618,362.807555 2154.65985,376.416919 2154.65985,392.671 C2154.65985,408.409079 2159.7553,421.889444 2169.94635,433.1125 C2180.1374,444.335556 2193.23077,449.947 2209.22685,449.947 Z M2401.29185,497.548 L2337.43685,288.568 L2397.03485,288.568 L2430.31685,414.343 L2469.40385,287.794 L2520.10085,287.794 L2559.57485,414.73 L2593.63085,288.568 L2652.06785,288.568 L2587.43885,497.548 L2534.41985,497.548 L2494.55885,370.225 L2453.92385,497.548 L2401.29185,497.548 Z"/>
                  <g fillRule="nonzero" transform="translate(39.94 40)">
                    <path d="M233.930875,7.4766892 L14.5407081,220.729863 C7.14759954,227.916164 2.99800399,237.655326 2.99800399,247.815709 L2.99800399,474.471398 C2.99800399,488.575951 14.7508142,500 29.2612669,500 L475.736737,500 C490.24719,500 502,488.575951 502,474.471398 L502,247.815709 C502,237.655326 497.850404,227.916164 490.457296,220.742627 L271.067129,7.4766892 C260.811325,-2.49222973 244.186679,-2.49222973 233.930875,7.4766892 Z"/>
                    <polygon fill="#1da1f2" points="42.232 460.526 42.232 246.971 252.499 43.062 462.766 246.971 462.766 460.526"/>
                    <polygon fill="#1da1f2" points="96.178 398.325 411.272 398.325 411.272 500 96.178 500"/>
                    <path fill="#1da1f2" d="M105.21218 257.177033L105.21218 500 27.051548 500C12.7220988 500 .998003992 488.497859.998003992 474.439688L.998003992 257.177033 105.21218 257.177033zM484.602518 220.85977L324.172437 61.0047847 253.112027 131.810465 393.440333 271.635735 393.440333 500 470.262399 500C484.346444 500 495.869754 488.517998 495.869754 474.48444L495.869754 247.906264C495.869754 237.827618 491.772578 228.004127 484.602518 220.85977z"/>
                    <path fill="#1da1f2" d="M327.349301,64.1108221 L2,377.401914 L2,250.760456 C2,240.69539 6.23390713,230.885136 13.6432446,223.750406 L234.732583,10.8551586 C245.052731,0.917498955 261.723741,0.917498955 272.043889,10.8551586 L327.349301,64.1108221 Z"/>
                    <g fill="#FFF" strokeLinejoin="round">
                      <use xlinkHref="#homeflow-v3-line-white-svg-a"/>
                      <use xlinkHref="#homeflow-v3-line-white-svg-a"/>
                    </g>
                  </g>
                </g>
              </svg>

              {/*<img src={assets('/media/img/logo_line.svg')} alt="Homeflow" style={{width:"160px"}}/>*/}
            </a>
            <button className="navbar-toggler" type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"/>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav ml-auto mt-2">
               {/* <li className="nav-item">
                  <a
                    href={'/#whyhomeflow'}
                    className={classNames({
                      'nav-link font-weight-500': true,
                      'active': (window.location.pathname === '/#whyhomeflow'),
                    })}>
                    <FormattedMessage id={'navigation.why'}/>
                  </a>
                </li>*/}

                {/*<li className="nav-item">
                  <Link
                    to={'/marketplace'}
                    className={classNames({
                      'nav-link font-weight-700': true,
                      'active': (window.location.pathname === '/marketplace'),
                    })}>
                    <i className="fad fa-shopping-bag"/> <FormattedMessage id={'navigation.shopping'}/>
                  </Link>
                </li>*/}

                {/*<li className="nav-item">
                  <a
                    href={'/'}
                    className={classNames({
                      'nav-link font-weight-700': true,
                      'active': (window.location.pathname === '/'),
                    })}>
                    <i className="fad fa-home-lg"/> <FormattedMessage id={'navigation.home'}/>
                  </a>
                </li>*/}

                <li className="nav-item">
                  <a
                    href={'/apps'}
                    className={classNames({
                      'nav-link font-weight-700': true,
                      'active': (window.location.pathname === '/apps'),
                    })}>
                    <i className="fad fa-mobile-android"/> <FormattedMessage id={'navigation.apps'}/>
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    href={'/solutions'}
                    className={classNames({
                      'nav-link font-weight-700': true,
                      'active': (window.location.pathname === '/solutions'),
                    })}>
                    <i className="fad fa-bring-front"/> <FormattedMessage id={'navigation.solutions'}/>
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    href={'/pricing'}
                    className={classNames({
                      'nav-link font-weight-700': true,
                      'active': (window.location.pathname === '/pricing'),
                    })}>
                    <i className={'fad fa-dollar-sign'}/> <FormattedMessage id={'navigation.price'}/>
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    href={media.app}
                    style={{borderRadius: '25px'}}
                    rel='noreferrer noopener'
                    className="nav-link btn btn-outline-light font-weight-700 pointer d-none d-lg-table-cell">
                    {/*<i className="fad fa-sign-in"/>*/} <FormattedMessage id={'navigation.create'}/> <i
                    className="fad fa-long-arrow-right text-primary"/>
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    aria-label={'Facebook'}
                    rel="noopener noreferrer"
                    className="nav-link"
                    href="https://www.facebook.com/homeflowapp"
                    target={'_blank'}>
                    <i className={'fab fa-facebook fa-lg hf-text-blue'}/>
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link googlesans-medium hf-blue"
                    href="https://twitter.com/HFlowTechnology"
                    rel="noopener noreferrer"
                    target={'_blank'}>
                    <i className="fab fa-twitter fa-lg hf-text-blue"/>
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    aria-label={'Instagram'}
                    rel="noopener noreferrer"
                    className="nav-link"
                    href="https://www.instagram.com/homeflow_technologies/"
                    target={'_blank'}>
                    <i className={'fab fa-instagram fa-lg hf-text-blue'}/>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    aria-label={'Instagram'}
                    rel="noopener noreferrer"
                    className="nav-link"
                    href="mailto:support@homeflowapp.com"
                    target={'_blank'}>
                    <i className={'fad fa-envelope-open fa-lg hf-text-blue'}/>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
    )
  }
}
